import { z } from 'zod';
import { OperationIdSchema } from '../../ids';
import { ItemAmountsSchema } from '../../models/items';
import { API_PREFIX, defineEndpoint } from '../endpoint';

/** A living community's id (the config's `communities.places`). */
const CommunityIdSchema = z.string().min(1).max(64);

/**
 * A living community's food (LOCAL-LIFE LL-4): public, like a banner. Its rations, what it eats a
 * game day and the most it keeps; below a few days of eating it asks its power's board for food.
 */
export const CommunityViewSchema = z.object({
  id: CommunityIdSchema,
  power: z.string(),
  /** The traced place it lives at. */
  place: z.string(),
  rations: z.number().int().nonnegative(),
  /** It has fallen (LL-4b): its people are gone until it stands up again. */
  fallen: z.boolean(),
  mouths: z.number().int().positive(),
  keeps: z.number().int().positive(),
});
export type CommunityView = z.infer<typeof CommunityViewSchema>;

/** Every living community's food (LL-4). */
export const getCommunities = defineEndpoint({
  method: 'GET',
  path: `${API_PREFIX}/communities`,
  access: 'session',
  response: z.object({ communities: z.array(CommunityViewSchema) }),
});

/**
 * Food brought to a community, standing by its place (LL-4, CY-2, CY-4): goods of the workers'
 * foods out of the backpack, a ration each; a day's eating or more is `aid` to its power.
 * Idempotent; refused beyond what it keeps.
 */
export const supplyCommunity = defineEndpoint({
  method: 'POST',
  path: `${API_PREFIX}/communities/:community/supply`,
  access: 'session',
  params: z.object({ community: CommunityIdSchema }),
  body: z.object({ operationId: OperationIdSchema, items: ItemAmountsSchema }),
  response: z.object({ rations: z.number().int().nonnegative() }),
});
